import axios from 'axios';

export const $saveOutside = ({empNo, startHour, startMinute, endHour, endMinute, startDate, endDate, desc}) => {
  return axios.post(`/api/outside`, {
    empNo, startHour, startMinute, endHour, endMinute, startDate, endDate, desc
  })
}

export const $getOutside = (empNo, date) => {
  return axios.get(`/api/outside/?&date=${date}&empNo=${empNo}`)
}

export const $removeOutside = (empNo, startTime) => {
  return axios.delete(`/api/outside/?startTime=${startTime}&empNo=${empNo}`)
}


// WEBPACK FOOTER //
// ./src/_api_/outsideAPI.js